import SectionTitle from "@/components/feature/SectionTitle";
import { voices } from "@/mocks/site";

export default function VoicesSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100">
      <SectionTitle
        eyebrow="网友怎么说"
        title="围观的人，都在这里接上了话"
        desc="来自常驻评论区的真实反馈，看看大家是怎么用爆料91把碎片化的讨论串起来的。"
        align="center"
      />

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {voices.map((voice, index) => (
          <figure
            key={voice.name}
            className={`flex flex-col rounded-2xl p-5 md:p-6 border ${
              index % 2 === 0
                ? "bg-background-50 border-background-200"
                : "bg-secondary-50 border-secondary-200"
            }`}
          >
            <span className="w-9 h-9 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
              <i className="ri-double-quotes-l text-lg"></i>
            </span>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
              {voice.content}
            </blockquote>
            <figcaption className="mt-5 pt-4 border-t border-background-200/70">
              <p className="text-sm font-bold text-foreground-950">{voice.name}</p>
              <p className="mt-0.5 text-xs text-foreground-500">{voice.role}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}